import { CloseOutlined, DeleteOutlined, SaveOutlined } from "@ant-design/icons";
import { Button, Col, Form, Input, Row, Space, Switch } from "antd";
import { useEffect, useState } from "react";
import { useViewportBreakpoint } from "../../hooks/useViewportBreakpoint";

const CompanyBaseItem = ({ itemDefault, onClose, onDelete, variant = "desktop" }) => {
  const [form] = Form.useForm();
  const [item, setItem] = useState({ ...itemDefault });
  const viewport = useViewportBreakpoint();
  const isMobile = viewport === "mobile";

  useEffect(() => form.setFieldsValue(item), []);

  const onValuesChange = value => setItem({ ...item, ...value });

  const switchRow = (name, label) =>
    isMobile ? (
      <div className="company-base-item-switch-row">
        <span>{label}</span>
        <Form.Item name={name} valuePropName="checked" noStyle>
          <Switch />
        </Form.Item>
      </div>
    ) : (
      <Space align="center">
        <Form.Item name={name} valuePropName="checked" noStyle>
          <Switch />
        </Form.Item>
        <span>{label}</span>
      </Space>
    );

  const mobileSwitchRow = (name, label) => (
    <div className="company-base-item-switch-row">
      <span>{label}</span>
      <Form.Item name={name} valuePropName="checked" noStyle>
        <Switch />
      </Form.Item>
    </div>
  );

  if (variant === "mobile") {
    return (
      <div className="company-base-item-root company-base-item-root--mobile">
        <Form
          form={form}
          onValuesChange={onValuesChange}
          layout="vertical"
          colon={false}
          className="company-base-item-form--mobile"
        >
          <Form.Item label="Пользователь" name="name">
            <Input />
          </Form.Item>
          <Form.Item label="">
            {mobileSwitchRow("isAct", "Активный")}
          </Form.Item>
          <Form.Item label="">
            {mobileSwitchRow("isNstr", "Получать настройки")}
          </Form.Item>
          <Form.Item label="Коэффициент цены" name="coeff">
            <Input />
          </Form.Item>
          <Form.Item label="">
            {mobileSwitchRow("isPack", "Отправлять пакеты")}
          </Form.Item>
          <Form.Item label="С отдела" name="depnoOld">
            <Input />
          </Form.Item>
          <Form.Item label="На отдел" name="depnoNew">
            <Input />
          </Form.Item>
          <Form.Item label="Комментарий" name="comment">
            <Input />
          </Form.Item>
          <div className="company-base-item-actions">
            <Button type="primary" icon={<SaveOutlined />} onClick={() => onClose(item)} aria-label="Сохранить" />
            <Button type="default" icon={<CloseOutlined />} onClick={() => onClose(false)} aria-label="Отмена" />
          </div>
        </Form>
      </div>
    );
  }

  return (
    <div>
      <Form form={form} onValuesChange={onValuesChange} labelCol={{ span: 6 }} wrapperCol={{ span: 18 }} colon={false}>
        <Form.Item label="Пользователь">
          <Row>
            <Col span={10}>
              <Form.Item name="name">
                <Input />
              </Form.Item>
            </Col>
            <Col span={2} />
            <Col span={12}>{switchRow("isAct", "Активный")}</Col>
          </Row>
        </Form.Item>
        <Form.Item label="Настройки">
          <Row>
            <Col span={10}>{switchRow("isNstr", "Получать")}</Col>
            <Col span={14}>
              <Form.Item label="Коэффициент цены" name="coeff">
                <Input />
              </Form.Item>
            </Col>
          </Row>
        </Form.Item>
        <Form.Item label="Пакеты">
          <Row>
            <Col span={6}>{switchRow("isPack", "Отправлять")}</Col>
            <Col span={1} />
            <Col span={8}>
              <Form.Item name="depnoOld" label="С отдела">
                <Input />
              </Form.Item>
            </Col>
            <Col span={1} />
            <Col span={8}>
              <Form.Item name="depnoNew" label="На отдел">
                <Input />
              </Form.Item>
            </Col>
          </Row>
        </Form.Item>
        <Form.Item label="Комментарий" name="comment">
          <Input />
        </Form.Item>
        <Form.Item label=" ">
          <Space>
            <Button danger icon={<DeleteOutlined />} onClick={() => onDelete(item.id)}>
              Удалить
            </Button>
            <Button onClick={() => onClose(item)}>Сохранить</Button>
            <Button onClick={() => onClose(false)}>Отмена</Button>
          </Space>
        </Form.Item>
      </Form>
    </div>
  );
};

export default CompanyBaseItem;
